import ModelTitleSummary from '../components/summary_section/ModelTitleSummary';
import { CartActions } from '../components/summary_section/CartActions';
import { IEMPicker } from '../components/name_and_price_section/IEMPicker';
import SettingsSection from '../components/settings_section/SettingsSection';
import ChoiceList from '../components/ChoiceList';
import InTheBoxDetails from '../components/summary_section/InTheBoxDetails';
import IEMPreview from '../components/iem_preview_section/IEMPreview';
import InTheBoxPreview from '../components/summary_section/InTheBoxPreview';
import IEMSections from '../components/category_list/IEMSections';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { debounce } from '@material-ui/core';
import { RESIZE_DEBOUNCE_DELAY } from '../constants';
import OrderDetails from '../components/summary_section/OrderDetails';
import layout from '../styles/layout.module.css';

const DesktopLayout = (props) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const currentCategory = useSelector(
        (state) => state.rootReducer.currentCategory.activeCategory
    );

    const previewRef = useRef(null);
    const [dimensions, setDimensions] = useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const resizeCanvas = () => {
        const previewBoxDimensions = previewRef.current?.getBoundingClientRect();
        setDimensions(previewBoxDimensions);
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        resizeCanvas();
        const debouncedResize = debounce(resizeCanvas, RESIZE_DEBOUNCE_DELAY);
        window.addEventListener('resize', debouncedResize);
        return () => {
            window.removeEventListener('resize', debouncedResize);
        };
    }, [previewRef, currentCategory]);

    return (
        <Box
            className={
                currentCategory === 'Summary' ? layout.gridContainerSummary : layout.gridContainer
            }>
            {currentCategory === 'Summary' ? (
                <Box className={layout.summaryInfo}>
                    <ModelTitleSummary />
                    <CartActions blob={props.blob} />
                    <OrderDetails height={dimensions.height} />
                </Box>
            ) : (
                <Box className={layout.modelPickerContainer}>
                    <IEMPicker width={props.width} modelList={props} />
                </Box>
            )}
            {currentCategory !== 'Model' &&
            currentCategory !== 'Care_plan' &&
            currentCategory !== 'Finalize' &&
            currentCategory !== 'Summary' ? (
                <Box className={layout.settings}>
                    <SettingsSection />
                </Box>
            ) : (
                <> </>
            )}
            <ChoiceList
                width={windowWidth}
                onMirror={props.onMirror}
                onFlip={props.onFlip}
                onReset={props.onReset}
                onCenter={props.onCenter}
            />
            {currentCategory === 'Summary' ? (
                <Box className={layout.summaryInBox}>
                    <Box className={layout.inBoxDescription}>
                        <InTheBoxDetails />
                    </Box>
                    <Box className={layout.inBoxPreview} ref={previewRef}>
                        <InTheBoxPreview
                            width={dimensions.width}
                            height={dimensions.height}
                            layerChanges={props.layerChanges}
                            setLayerChanges={props.setLayerChanges}
                            image={props.blob}
                            onBlob={props.onBlob}
                        />
                    </Box>
                </Box>
            ) : (
                <div className={layout.iemPreview} ref={previewRef}>
                    <IEMPreview
                        width={dimensions.width}
                        height={dimensions.height}
                        layerChanges={props.layerChanges}
                        setLayerChanges={props.setLayerChanges}
                        onBlob={props.onBlob}
                        artworkPositioning={props.artworkPositioning}
                        layers={props.layers}
                        onLoad={props.onLoad}
                        handleLayerChange={props.handleLayerChange}
                        onFlip={props.onFlip}
                        onMirror={props.onMirror}
                        onReset={props.onReset}
                    />
                </div>
            )}
            <Box className={layout.menu}>
                <IEMSections />
            </Box>
        </Box>
    );
};
export default DesktopLayout;
